import React from 'react';
import { NativeTypes } from 'react-dnd-html5-backend';
import { useDrop } from 'react-dnd';
import styled from 'styled-components';

const Container = styled.div`
    border: ${props => props.isActive ? '2px dashed #00b4d8' : '2px dashed var(--secondary-accent-color)'};
    border-radius: 5px;
`

export const Dropzone = (props) => {
    const { onDrop } = props;
    const [{ canDrop, isOver }, drop] = useDrop({
        accept: [NativeTypes.FILE],
        drop(item, monitor) {
            if (onDrop) {
                onDrop(props, monitor);
            }
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    });
    const isActive = canDrop && isOver;
    return (<Container ref={drop} isActive={isActive}>
			{/* {isActive ? 'Release to drop' : 'Drag file here'} */}
            {props.children}
		</Container>);
};

export default Dropzone